import clsx from 'clsx';

import type { ButtonProps } from './Button';
import s from './Button.module.scss';
import ButtonOutlined from './ButtonOutlined';

const ButtonOutlinedSmall = ({ className, ...props }: ButtonProps) => (
  <ButtonOutlined className={clsx(s.small, className)} {...props} />
);

export default ButtonOutlinedSmall;
